export class PayLoadPix {
    ID_PAYLOAD_FORMAT_INDICATOR = '00';
    ID_POINT_INITIATION_METHOD = '01';
    ID_MERCHANT_ACCOUNT_INFORMATION = '26';
    ID_MERCHANT_ACCOUNT_INFORMATION_GUI = '00';
    ID_MERCHANT_ACCOUNT_INFORMATION_KEY = '01';
    ID_MERCHANT_ACCOUNT_INFORMATION_URL = '25';
    ID_MERCHANT_ACCOUNT_INFORMATION_DESCRIPTION = '02';
    ID_MERCHANT_CATEGORY_CODE = '52';
    ID_TRANSACTION_CURRENCY = '53';
    ID_TRANSACTION_AMOUNT = '54';
    ID_COUNTRY_CODE = '58';
    ID_MERCHANT_NAME = '59';
    ID_MERCHANT_CITY = '60';
    ID_ADDITIONAL_DATA_FIELD_TEMPLATE = '62';
    ID_ADDITIONAL_DATA_FIELD_TEMPLATE_TXID = '05';
    ID_CRC16 = '6304';

    pixKey = '';
    url = '';
    description = '';
    merchantName = '';
    merchantCity = '';
    txid = '';
    amount = '';

    getValue(id: any, value: string) {
        let size = value.length;
        let strSize = size.toString().padStart(2, '0');
        return id + strSize + value;
    }

    getMerchantMerchantAccountInformation() {
        let gui = this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION_GUI, 'br.gov.bcb.pix');
        let key = this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION_KEY, this.pixKey);
        //let key = this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION_URL, this.url);
        //let descriptionPayment = this.description.length > 0 ? this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION_DESCRIPTION, this.description) : '';
        //return this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION,gui+key+descriptionPayment);
        return this.getValue(this.ID_MERCHANT_ACCOUNT_INFORMATION, gui + key);
    }

    getAdditionalDataTemplate() {
        let txid = this.getValue(this.ID_ADDITIONAL_DATA_FIELD_TEMPLATE_TXID, this.txid);
        return this.getValue(this.ID_ADDITIONAL_DATA_FIELD_TEMPLATE, txid);
    }

    getPayLoad() {
        let payLoad = this.getValue(this.ID_PAYLOAD_FORMAT_INDICATOR, '01') +
            this.getValue(this.ID_POINT_INITIATION_METHOD, "12") +
            this.getMerchantMerchantAccountInformation() +

            this.getValue(this.ID_MERCHANT_CATEGORY_CODE, "0000") +
            this.getValue(this.ID_TRANSACTION_CURRENCY, "986") +
            this.getValue(this.ID_TRANSACTION_AMOUNT, this.amount) +
            this.getValue(this.ID_COUNTRY_CODE, "BR") +
            this.getValue(this.ID_MERCHANT_NAME, this.merchantName) +
            this.getValue(this.ID_MERCHANT_CITY, this.merchantCity) +
            this.getAdditionalDataTemplate();

        return payLoad + this.getGerarCRC16(payLoad);
    }

    getGerarCRC16(payload) {
        let polinomio = 0x1021;
        let resultado = 0xFFFF;
        if (payload > 0) {
            let length = payload.length;
            for (let offset = 0; offset < length; offset++) {
                resultado ^= ((payload[offset]) << 8);
                for (let bitwise = 0; bitwise < 8; bitwise++) {
                    if ((resultado <<= 1) & 0x10000) resultado ^= polinomio;
                    resultado += 0xFFFF;
                }
            }
        }
        return this.ID_CRC16 + resultado.toString(16).toUpperCase();

    }

    /*
    crc16(string: any){
        let CRC16POLINOMIO = 0x1021;
        let result = 0xFFFF;
        let length = string.length;
        if (string.length > 0) {
        for (let offset = 0; offset < length; offset++) {

            result ^= ((string[offset]) << 8);
        
            for (let bitwise = 0; bitwise < 8; bitwise++) {
            if ((result <<= 1) & 0x10000) result ^= CRC16POLINOMIO;
                result += 0xFFFF;
            }
        }
    }
        return result;
    }
    */

    /*
    function crc16($data){
        $crc = 0xFFFF;
        for ($i = 0; $i < strlen($data); $i++)
        {
            $x = (($crc >> 8) ^ ord($data[$i])) & 0xFF;
            $x ^= $x >> 4;
            $crc = (($crc << 8) ^ ($x << 12) ^ ($x << 5) ^ $x) & 0xFFFF;
        }
        return $crc;
    }
     */
}